import { render, staticRenderFns } from "./CriticalError.vue?vue&type=template&id=2db31133&scoped=true"
import script from "./CriticalError.vue?vue&type=script&lang=js"
export * from "./CriticalError.vue?vue&type=script&lang=js"
import style0 from "./CriticalError.vue?vue&type=style&index=0&id=2db31133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db31133",
  null
  
)

export default component.exports